import { Button } from 'primereact/button';
import classes from './supplierForecastSearch.module.scss';
import { useSupplierForecastSearch } from './useSupplierForecastSearch.logic';
import { ProgressSpinner } from 'primereact/progressspinner';
import SearchIcon from 'assets/icons/searchIcon.svg';
import { Divider } from 'primereact/divider';
import { AutoComplete } from 'primereact/autocomplete';
import { observer } from 'mobx-react';

const SupplierForecastSearchBar = () => {
  const {
    isSupplierForecastLoading,
    searchRef,
    searchInput,
    filteredndc10SearchData,
    filterConceptSearchData,
    handleSearch,
    handleSearchInputChange,
    handleFilterConceptSearch,
    handleEnterKeyDownSearchInput,
  } = useSupplierForecastSearch();

  return (
    <div className={classes.drugSearchBar}>
      <Button
        outlined
        data-testid="drugSearchButton"
        className={classes.searchIconButton}
        onClick={handleSearch}
        disabled={searchInput ? false : true}
      >
        {!isSupplierForecastLoading ? (
          <img className={classes.searchIcon} src={SearchIcon} alt="search icon" />
        ) : (
          <ProgressSpinner
            style={{ width: '25px', height: '25px' }}
            strokeWidth="8"
            fill="var(--surface-ground)"
            animationDuration="1s"
          />
        )}
      </Button>
      <Divider className={classes.divider} layout="vertical" />

      <div className={classes.searchbarRightSection}>
        <AutoComplete
          onLoad={() => {
            if (searchRef) searchRef.current?.focus();
          }}
          ref={searchRef}
          autoFocus
          onSelect={handleSearch}
          minLength={1}
          field="value"
          delay={100}
          autoHighlight={true}
          disabled={isSupplierForecastLoading}
          onKeyDown={handleEnterKeyDownSearchInput}
          placeholder="Search for Drug Concept & NDC10"
          style={{ flexGrow: 1 }}
          className={classes.searchField}
          value={searchInput}
          completeMethod={handleFilterConceptSearch}
          suggestions={
            searchInput?.match(/^\d/) ? filteredndc10SearchData : filterConceptSearchData
          }
          dropdownIcon={null}
          onChange={e => handleSearchInputChange(e.value.value ? e.value.value : e.value)}
        />
      </div>
    </div>
  );
};

export default observer(SupplierForecastSearchBar);
